/* eslint-disable import/no-webpack-loader-syntax */
import React from "react";
import classNames from "classnames";
import { compose } from "recompose";
import { withLanguage } from "components/common";
import { createPortal } from "react-dom";
import container from "raw-loader!./container.html";

export const Document = ({
  getRef,
  template,
  className,
  root,
  visible,
  language,
  dir,
  children,
  i18n,
  t,
  tReady,
  i18nOptions,
  defaultNS,
  reportNS,
  ...props
}) => (
  <iframe
    ref={getRef}
    title="document"
    srcDoc={container}
    className={classNames(!visible ? "d-none" : "", className)}
    {...props}
  >
    {root
      ? createPortal(
          <div className={i18n.dir()} dir={i18n.dir()}>
            {children}
          </div>,
          root
        )
      : null}
  </iframe>
);

export const enhance = compose(withLanguage((props) => props.language));

export default enhance(Document);
